import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { Callout } from './ui';
import { useAuth } from '../hooks/useAuth';
import { t } from '../i18n';

export function ProtectedRoute() {
  const { isAuthenticated, isSuperAdmin, needsCompanySetup } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (isSuperAdmin) {
    const onPlatform =
      location.pathname === '/platform/tenants' ||
      location.pathname.startsWith('/platform/');
    if (!onPlatform) {
      return <Navigate to="/platform/tenants" replace />;
    }
    return <Outlet />;
  }

  if (
    location.pathname === '/platform' ||
    location.pathname.startsWith('/platform/')
  ) {
    return <Navigate to="/" replace />;
  }

  if (needsCompanySetup && location.pathname !== '/setup/company') {
    return <Navigate to="/setup/company" replace />;
  }

  if (!needsCompanySetup && location.pathname === '/setup/company') {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}

export function AdminRoute() {
  const { isAuthenticated, isAdmin } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!isAdmin) {
    return (
      <Callout variant="warning" className="m-6">
        {t().common.accessDenied}
      </Callout>
    );
  }

  return <Outlet />;
}

export function SuperAdminRoute() {
  const { isAuthenticated, isSuperAdmin } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!isSuperAdmin) {
    return (
      <Callout variant="warning" className="m-6">
        {t().common.accessDenied}
      </Callout>
    );
  }

  return <Outlet />;
}
